export const parametrosAlturaNino = {
  0: {
    P3: [
      46.0, 46.5, 47.0, 47.6, 48.1, 48.6, 49.1, 49.6, 50.1, 50.6, 51.1, 51.6,
      52.1, 52.6, 53.1, 53.6, 54.1, 54.6, 55.1, 55.6, 56.1, 56.6, 57.1, 57.6,
      58.1, 58.6, 59.1,
    ],
    P25: [
      47.1, 47.6, 48.2, 48.8, 49.4, 50.0, 50.5, 51.1, 51.7, 52.3, 52.8, 53.4,
      53.9, 54.5, 55.0, 55.6, 56.1, 56.7, 57.2, 57.8, 58.3, 58.9, 59.4, 60.0,
      60.5, 61.1, 61.6,
    ],
    P50: [
      49.8, 50.3, 50.9, 51.5, 52.1, 52.7, 53.3, 53.9, 54.5, 55.1, 55.7, 56.3,
      56.9, 57.5, 58.1, 58.7, 59.3, 59.9, 60.5, 61.1, 61.7, 62.3, 62.9, 63.5,
      64.1, 64.7, 65.3,
    ],
    P75: [
      52.4, 53.0, 53.6, 54.2, 54.8, 55.4, 56.0, 56.6, 57.2, 57.8, 58.4, 59.0,
      59.6, 60.2, 60.8, 61.4, 62.0, 62.6, 63.2, 63.8, 64.4, 65.0, 65.6, 66.2,
      66.8, 67.4, 68.0,
    ],
    P97: [
      54.0, 54.6, 55.2, 55.8, 56.4, 57.0, 57.6, 58.2, 58.8, 59.4, 60.0, 60.6,
      61.2, 61.8, 62.4, 63.0, 63.6, 64.2, 64.8, 65.4, 66.0, 66.6, 67.2, 67.8,
      68.4, 69.0, 69.6,
    ],
  },
  1: {
    P3: [
      57.1, 57.5, 57.9, 58.3, 58.7, 59.1, 59.5, 59.9, 60.3, 60.7, 61.1, 61.5,
      61.9, 62.3, 62.7, 63.1, 63.5, 63.9, 64.3, 64.7, 65.1, 65.5, 65.9, 66.3,
      66.7, 67.1,
    ],
    P25: [
      59.3, 59.7, 60.1, 60.5, 60.9, 61.3, 61.7, 62.1, 62.5, 62.9, 63.3, 63.7,
      64.1, 64.5, 64.9, 65.3, 65.7, 66.1, 66.5, 66.9, 67.3, 67.7, 68.1, 68.5,
      68.9, 69.3,
    ],
    P50: [
      61.7, 62.1, 62.5, 62.9, 63.3, 63.7, 64.1, 64.5, 64.9, 65.3, 65.7, 66.1,
      66.5, 66.9, 67.3, 67.7, 68.1, 68.5, 68.9, 69.3, 69.7, 70.1, 70.5, 70.9,
      71.3, 71.7,
    ],
    P75: [
      64.0, 64.4, 64.8, 65.2, 65.6, 66.0, 66.4, 66.8, 67.2, 67.6, 68.0, 68.4,
      68.8, 69.2, 69.6, 70.0, 70.4, 70.8, 71.2, 71.6, 72.0, 72.4, 72.8, 73.2,
      73.6, 74.0,
    ],
    P97: [
      66.2, 66.6, 67.0, 67.4, 67.8, 68.2, 68.6, 69.0, 69.4, 69.8, 70.2, 70.6,
      71.0, 71.4, 71.8, 72.2, 72.6, 73.0, 73.4, 73.8, 74.2, 74.6, 75.0, 75.4,
      75.8, 76.2,
    ],
  },
  2: {
    P3: [
      72.0, 72.5, 73.0, 73.5, 74.0, 74.5, 75.0, 75.5, 76.0, 76.5, 77.0, 77.5,
      78.0, 78.5, 79.0, 79.5, 80.0, 80.5, 81.0, 81.5, 82.0, 82.5, 83.0, 83.5,
    ],
    P25: [
      74.0, 74.5, 75.0, 75.5, 76.0, 76.5, 77.0, 77.5, 78.0, 78.5, 79.0, 79.5,
      80.0, 80.5, 81.0, 81.5, 82.0, 82.5, 83.0, 83.5, 84.0, 84.5, 85.0, 85.5,
    ],
    P50: [
      76.0, 76.5, 77.0, 77.5, 78.0, 78.5, 79.0, 79.5, 80.0, 80.5, 81.0, 81.5,
      82.0, 82.5, 83.0, 83.5, 84.0, 84.5, 85.0, 85.5, 86.0, 86.5, 87.0, 87.5,
    ],
    P75: [
      78.0, 78.5, 79.0, 79.5, 80.0, 80.5, 81.0, 81.5, 82.0, 82.5, 83.0, 83.5,
      84.0, 84.5, 85.0, 85.5, 86.0, 86.5, 87.0, 87.5, 88.0, 88.5, 89.0, 89.5,
    ],
    P97: [
      80.0, 80.5, 81.0, 81.5, 82.0, 82.5, 83.0, 83.5, 84.0, 84.5, 85.0, 85.5,
      86.0, 86.5, 87.0, 87.5, 88.0, 88.5, 89.0, 89.5, 90.0, 90.5, 91.0, 91.5,
    ],
  },
  3: {
    P3: [
      90.0, 90.5, 91.0, 91.5, 92.0, 92.5, 93.0, 93.5, 94.0, 94.5, 95.0, 95.5,
    ],
    P25: [
      92.0, 92.5, 93.0, 93.5, 94.0, 94.5, 95.0, 95.5, 96.0, 96.5, 97.0, 97.5,
    ],
    P50: [
      94.0, 94.5, 95.0, 95.5, 96.0, 96.5, 97.0, 97.5, 98.0, 98.5, 99.0, 99.5,
    ],
    P75: [
      96.0, 96.5, 97.0, 97.5, 98.0, 98.5, 99.0, 99.5, 100.0, 100.5, 101.0,
      101.5,
    ],
    P97: [
      98.0, 98.5, 99.0, 99.5, 100.0, 100.5, 101.0, 101.5, 102.0, 102.5, 103.0,
      103.5,
    ],
  },
  4: {
    P3: [
      104.0, 105.5, 107.0, 108.5, 110.0, 111.5, 113.0, 114.5, 116.0, 117.5,
      119.0, 120.5, 122.0, 123.5, 125.0, 126.5, 128.0, 129.5, 131.0, 132.5,
    ],
    P25: [
      108.5, 110.0, 111.5, 113.0, 114.5, 116.0, 117.5, 119.0, 120.5, 122.0,
      123.5, 125.0, 126.5, 128.0, 129.5, 131.0, 132.5, 134.0, 135.5, 137.0,
    ],
    P50: [
      113.0, 114.5, 116.0, 117.5, 119.0, 120.5, 122.0, 123.5, 125.0, 126.5,
      128.0, 129.5, 131.0, 132.5, 134.0, 135.5, 137.0, 138.5, 140.0, 141.5,
    ],
    P75: [
      117.5, 119.0, 120.5, 122.0, 123.5, 125.0, 126.5, 128.0, 129.5, 131.0,
      132.5, 134.0, 135.5, 137.0, 138.5, 140.0, 141.5, 143.0, 144.5, 146.0,
    ],
    P97: [
      122.5, 124.0, 125.5, 127.0, 128.5, 130.0, 131.5, 133.0, 134.5, 136.0,
      137.5, 139.0, 140.5, 142.0, 143.5, 145.0, 146.5, 148.0, 149.5, 151.0,
    ],
  },
};

export const parametrosAlturaNina = {
  0: {
    P3: [
      45.4, 46.0, 46.5, 47.1, 47.6, 48.1, 48.6, 49.0, 49.5, 50.0, 50.4, 50.9,
      51.3, 51.7, 52.1, 52.5, 52.9, 53.3, 53.7, 54.0, 54.4, 54.8, 55.1, 55.5,
      55.8, 56.1, 56.4,
    ],
    P25: [
      46.5, 47.1, 47.7, 48.3, 48.9, 49.4, 50.0, 50.5, 51.0, 51.5, 52.0, 52.5,
      53.0, 53.4, 53.9, 54.3, 54.8, 55.2, 55.7, 56.1, 56.5, 56.9, 57.3, 57.7,
      58.0, 58.4, 58.7,
    ],
    P50: [
      49.1, 49.7, 50.3, 50.9, 51.5, 52.1, 52.7, 53.3, 53.9, 54.5, 55.0, 55.6,
      56.2, 56.7, 57.3, 57.8, 58.3, 58.8, 59.3, 59.8, 60.3, 60.8, 61.2, 61.7,
      62.1, 62.5, 63.0,
    ],
    P75: [
      51.6, 52.2, 52.8, 53.4, 54.0, 54.6, 55.2, 55.8, 56.4, 57.0, 57.6, 58.2,
      58.8, 59.3, 59.9, 60.4, 61.0, 61.5, 62.0, 62.5, 63.0, 63.5, 64.0, 64.5,
      65.0, 65.5, 66.0,
    ],
    P97: [
      52.9, 53.5, 54.1, 54.7, 55.3, 55.9, 56.5, 57.1, 57.7, 58.3, 58.9, 59.5,
      60.1, 60.7, 61.3, 61.9, 62.5, 63.0, 63.6, 64.1, 64.7, 65.2, 65.8, 66.3,
      66.9, 67.4, 68.0,
    ],
  },
  1: {
    P3: [
      56.5, 56.9, 57.2, 57.6, 58.0, 58.3, 58.7, 59.0, 59.4, 59.7, 60.0, 60.4,
      60.7, 61.0, 61.3, 61.7, 62.0, 62.3, 62.6, 63.0, 63.3, 63.6, 63.9, 64.2,
      64.5, 64.8,
    ],
    P25: [
      58.7, 59.1, 59.5, 59.9, 60.3, 60.7, 61.1, 61.5, 61.9, 62.3, 62.7, 63.1,
      63.5, 63.9, 64.3, 64.7, 65.1, 65.5, 65.9, 66.3, 66.7, 67.1, 67.5, 67.9,
      68.3, 68.7,
    ],
    P50: [
      61.0, 61.4, 61.8, 62.2, 62.6, 63.0, 63.4, 63.8, 64.2, 64.6, 65.0, 65.4,
      65.8, 66.2, 66.6, 67.0, 67.4, 67.8, 68.2, 68.6, 69.0, 69.4, 69.8, 70.2,
      70.6, 71.0,
    ],
    P75: [
      63.3, 63.7, 64.1, 64.5, 64.9, 65.3, 65.7, 66.1, 66.5, 66.9, 67.3, 67.7,
      68.1, 68.5, 68.9, 69.3, 69.7, 70.1, 70.5, 70.9, 71.3, 71.7, 72.1, 72.5,
      72.9, 73.3,
    ],
    P97: [
      65.5, 65.9, 66.3, 66.7, 67.1, 67.5, 67.9, 68.3, 68.7, 69.1, 69.5, 69.9,
      70.3, 70.7, 71.1, 71.5, 71.9, 72.3, 72.7, 73.1, 73.5, 73.9, 74.3, 74.7,
      75.1, 75.5,
    ],
  },
  2: {
    P3: [
      71.5, 72.0, 72.5, 73.0, 73.5, 74.0, 74.5, 75.0, 75.5, 76.0, 76.5, 77.0,
      77.5, 78.0, 78.5, 79.0, 79.5, 80.0, 80.5, 81.0, 81.5, 82.0, 82.5, 83.0,
    ],
    P25: [
      73.5, 74.0, 74.5, 75.0, 75.5, 76.0, 76.5, 77.0, 77.5, 78.0, 78.5, 79.0,
      79.5, 80.0, 80.5, 81.0, 81.5, 82.0, 82.5, 83.0, 83.5, 84.0, 84.5, 85.0,
    ],
    P50: [
      75.5, 76.0, 76.5, 77.0, 77.5, 78.0, 78.5, 79.0, 79.5, 80.0, 80.5, 81.0,
      81.5, 82.0, 82.5, 83.0, 83.5, 84.0, 84.5, 85.0, 85.5, 86.0, 86.5, 87.0,
    ],
    P75: [
      77.5, 78.0, 78.5, 79.0, 79.5, 80.0, 80.5, 81.0, 81.5, 82.0, 82.5, 83.0,
      83.5, 84.0, 84.5, 85.0, 85.5, 86.0, 86.5, 87.0, 87.5, 88.0, 88.5, 89.0,
    ],
    P97: [
      79.5, 80.0, 80.5, 81.0, 81.5, 82.0, 82.5, 83.0, 83.5, 84.0, 84.5, 85.0,
      85.5, 86.0, 86.5, 87.0, 87.5, 88.0, 88.5, 89.0, 89.5, 90.0, 90.5, 91.0,
    ],
  },
  3: {
    P3: [
      89.0, 89.5, 90.0, 90.5, 91.0, 91.5, 92.0, 92.5, 93.0, 93.5, 94.0, 94.5,
    ],
    P25: [
      91.0, 91.5, 92.0, 92.5, 93.0, 93.5, 94.0, 94.5, 95.0, 95.5, 96.0, 96.5,
    ],
    P50: [
      93.0, 93.5, 94.0, 94.5, 95.0, 95.5, 96.0, 96.5, 97.0, 97.5, 98.0, 98.5,
    ],
    P75: [
      95.0, 95.5, 96.0, 96.5, 97.0, 97.5, 98.0, 98.5, 99.0, 99.5, 100.0, 100.5,
    ],
    P97: [
      97.0, 97.5, 98.0, 98.5, 99.0, 99.5, 100.0, 100.5, 101.0, 101.5, 102.0,
      102.5,
    ],
  },
  4: {
    P3: [
      102.5, 104.0, 105.5, 107.0, 108.5, 110.0, 111.5, 113.0, 114.5, 116.0,
      117.5, 119.0, 120.5, 122.0, 123.5, 125.0, 126.5, 128.0, 129.5, 131.0,
    ],
    P25: [
      107.0, 108.5, 110.0, 111.5, 113.0, 114.5, 116.0, 117.5, 119.0, 120.5,
      122.0, 123.5, 125.0, 126.5, 128.0, 129.5, 131.0, 132.5, 134.0, 135.5,
    ],
    P50: [
      111.5, 113.0, 114.5, 116.0, 117.5, 119.0, 120.5, 122.0, 123.5, 125.0,
      126.5, 128.0, 129.5, 131.0, 132.5, 134.0, 135.5, 137.0, 138.5, 140.0,
    ],
    P75: [
      116.0, 117.5, 119.0, 120.5, 122.0, 123.5, 125.0, 126.5, 128.0, 129.5,
      131.0, 132.5, 134.0, 135.5, 137.0, 138.5, 140.0, 141.5, 143.0, 144.5,
    ],
    P97: [
      121.0, 122.5, 124.0, 125.5, 127.0, 128.5, 130.0, 131.5, 133.0, 134.5,
      136.0, 137.5, 139.0, 140.5, 142.0, 143.5, 145.0, 146.5, 148.0, 149.5,
    ],
  },
};

export const parametrosPesoNino = {
  0: {
    P3: [
      2.6, 2.8, 3.0, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4.0, 4.1, 4.2, 4.3,
      4.4, 4.5, 4.6, 4.7, 4.8, 4.9, 5.0, 5.1, 5.2, 5.3, 5.4,
    ],
    P25: [
      3.0, 3.2, 3.4, 3.6, 3.7, 3.9, 4.0, 4.2, 4.3, 4.5, 4.6, 4.8, 4.9, 5.1, 5.2,
      5.4, 5.5, 5.7, 5.8, 6.0, 6.1, 6.3, 6.4, 6.6, 6.7, 6.9,
    ],
    P50: [
      3.4, 3.6, 3.8, 4.0, 4.2, 4.4, 4.6, 4.8, 5.0, 5.2, 5.4, 5.6, 5.8, 6.0, 6.2,
      6.4, 6.6, 6.8, 7.0, 7.2, 7.4, 7.6, 7.8, 8.0, 8.2, 8.4,
    ],
    P75: [
      3.8, 4.0, 4.2, 4.4, 4.6, 4.8, 5.0, 5.2, 5.4, 5.6, 5.8, 6.0, 6.2, 6.4, 6.6,
      6.8, 7.0, 7.2, 7.4, 7.6, 7.8, 8.0, 8.2, 8.4, 8.6, 8.8,
    ],
    P97: [
      4.2, 4.4, 4.6, 4.8, 5.0, 5.2, 5.4, 5.6, 5.8, 6.0, 6.2, 6.4, 6.6, 6.8, 7.0,
      7.2, 7.4, 7.6, 7.8, 8.0, 8.2, 8.4, 8.6, 8.8, 9.0, 9.2,
    ],
  },
  1: {
    P3: [
      5.6, 5.7, 5.8, 5.9, 6.0, 6.1, 6.2, 6.3, 6.4, 6.5, 6.6, 6.7, 6.8, 6.9, 7.0,
      7.1, 7.2, 7.3, 7.4, 7.5, 7.6, 7.7, 7.8, 7.9, 8.0, 8.1,
    ],
    P25: [
      6.2, 6.3, 6.4, 6.5, 6.6, 6.7, 6.8, 6.9, 7.0, 7.1, 7.2, 7.3, 7.4, 7.5, 7.6,
      7.7, 7.8, 7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7,
    ],
    P50: [
      6.8, 6.9, 7.0, 7.1, 7.2, 7.3, 7.4, 7.5, 7.6, 7.7, 7.8, 7.9, 8.0, 8.1, 8.2,
      8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9, 9.0, 9.1, 9.2, 9.3,
    ],
    P75: [
      7.4, 7.5, 7.6, 7.7, 7.8, 7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8,
      8.9, 9.0, 9.1, 9.2, 9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9,
    ],
    P97: [
      8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9, 9.0, 9.1, 9.2, 9.3, 9.4,
      9.5, 9.6, 9.7, 9.8, 9.9, 10.0, 10.1, 10.2, 10.3, 10.4, 10.5,
    ],
  },
  2: {
    P3: [
      8.5, 8.7, 8.9, 9.1, 9.3, 9.5, 9.7, 9.9, 10.1, 10.3, 10.5, 10.7, 10.9,
      11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9, 13.1,
    ],
    P25: [
      9.3, 9.5, 9.7, 9.9, 10.1, 10.3, 10.5, 10.7, 10.9, 11.1, 11.3, 11.5, 11.7,
      11.9, 12.1, 12.3, 12.5, 12.7, 12.9, 13.1, 13.3, 13.5, 13.7, 13.9,
    ],
    P50: [
      10.1, 10.3, 10.5, 10.7, 10.9, 11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3,
      12.5, 12.7, 12.9, 13.1, 13.3, 13.5, 13.7, 13.9, 14.1, 14.3, 14.5, 14.7,
    ],
    P75: [
      10.9, 11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9, 13.1,
      13.3, 13.5, 13.7, 13.9, 14.1, 14.3, 14.5, 14.7, 14.9, 15.1, 15.3, 15.5,
    ],
    P97: [
      11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9, 13.1, 13.3, 13.5, 13.7, 13.9,
      14.1, 14.3, 14.5, 14.7, 14.9, 15.1, 15.3, 15.5, 15.7, 15.9, 16.1, 16.3,
    ],
  },
  3: {
    P3: [
      12.8, 13.0, 13.2, 13.4, 13.6, 13.8, 14.0, 14.2, 14.4, 14.6, 14.8, 15.0,
    ],
    P25: [
      13.6, 13.8, 14.0, 14.2, 14.4, 14.6, 14.8, 15.0, 15.2, 15.4, 15.6, 15.8,
    ],
    P50: [
      14.4, 14.6, 14.8, 15.0, 15.2, 15.4, 15.6, 15.8, 16.0, 16.2, 16.4, 16.6,
    ],
    P75: [
      15.2, 15.4, 15.6, 15.8, 16.0, 16.2, 16.4, 16.6, 16.8, 17.0, 17.2, 17.4,
    ],
    P97: [
      16.0, 16.2, 16.4, 16.6, 16.8, 17.0, 17.2, 17.4, 17.6, 17.8, 18.0, 18.2,
    ],
  },
  4: {
    P3: [
      14.5, 15.0, 15.5, 16.0, 16.5, 17.0, 17.5, 18.0, 18.5, 19.0, 19.5, 20.0,
      20.5, 21.0, 21.5, 22.0, 22.5, 23.0, 23.5, 24.0,
    ],
    P25: [
      16.0, 16.5, 17.0, 17.5, 18.0, 18.5, 19.0, 19.5, 20.0, 20.5, 21.0, 21.5,
      22.0, 22.5, 23.0, 23.5, 24.0, 24.5, 25.0, 25.5,
    ],
    P50: [
      17.5, 18.0, 18.5, 19.0, 19.5, 20.0, 20.5, 21.0, 21.5, 22.0, 22.5, 23.0,
      23.5, 24.0, 24.5, 25.0, 25.5, 26.0, 26.5, 27.0,
    ],
    P75: [
      19.0, 19.5, 20.0, 20.5, 21.0, 21.5, 22.0, 22.5, 23.0, 23.5, 24.0, 24.5,
      25.0, 25.5, 26.0, 26.5, 27.0, 27.5, 28.0, 28.5,
    ],
    P97: [
      20.5, 21.0, 21.5, 22.0, 22.5, 23.0, 23.5, 24.0, 24.5, 25.0, 25.5, 26.0,
      26.5, 27.0, 27.5, 28.0, 28.5, 29.0, 29.5, 30.0,
    ],
  },
};

export const parametrosPesoNina = {
  0: {
    P3: [
      2.5, 2.7, 2.9, 3.0, 3.1, 3.2, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4.0, 4.1, 4.2,
      4.3, 4.4, 4.5, 4.6, 4.7, 4.8, 4.9, 5.0, 5.1, 5.2, 5.3,
    ],
    P25: [
      2.9, 3.1, 3.3, 3.5, 3.6, 3.7, 3.9, 4.0, 4.2, 4.3, 4.5, 4.6, 4.7, 4.9, 5.0,
      5.2, 5.3, 5.5, 5.6, 5.8, 5.9, 6.0, 6.2, 6.3, 6.4, 6.6,
    ],
    P50: [
      3.2, 3.4, 3.6, 3.8, 4.0, 4.2, 4.4, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9,
      6.1, 6.3, 6.5, 6.7, 6.9, 7.1, 7.3, 7.5, 7.7, 7.9, 8.1,
    ],
    P75: [
      3.6, 3.8, 4.0, 4.2, 4.4, 4.6, 4.8, 5.0, 5.2, 5.4, 5.6, 5.8, 6.0, 6.2, 6.4,
      6.6, 6.8, 7.0, 7.2, 7.4, 7.6, 7.8, 8.0, 8.2, 8.4, 8.6,
    ],
    P97: [
      4.0, 4.2, 4.4, 4.6, 4.8, 5.0, 5.2, 5.4, 5.6, 5.8, 6.0, 6.2, 6.4, 6.6, 6.8,
      7.0, 7.2, 7.4, 7.6, 7.8, 8.0, 8.2, 8.4, 8.6, 8.8, 9.0,
    ],
  },
  1: {
    P3: [
      5.4, 5.5, 5.6, 5.7, 5.8, 5.9, 6.0, 6.1, 6.2, 6.3, 6.4, 6.5, 6.6, 6.7, 6.8,
      6.9, 7.0, 7.1, 7.2, 7.3, 7.4, 7.5, 7.6, 7.7, 7.8, 7.9,
    ],
    P25: [
      6.0, 6.1, 6.2, 6.3, 6.4, 6.5, 6.6, 6.7, 6.8, 6.9, 7.0, 7.1, 7.2, 7.3, 7.4,
      7.5, 7.6, 7.7, 7.8, 7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5,
    ],
    P50: [
      6.6, 6.7, 6.8, 6.9, 7.0, 7.1, 7.2, 7.3, 7.4, 7.5, 7.6, 7.7, 7.8, 7.9, 8.0,
      8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9, 9.0, 9.1,
    ],
    P75: [
      7.2, 7.3, 7.4, 7.5, 7.6, 7.7, 7.8, 7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6,
      8.7, 8.8, 8.9, 9.0, 9.1, 9.2, 9.3, 9.4, 9.5, 9.6, 9.7,
    ],
    P97: [
      7.8, 7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9, 9.0, 9.1, 9.2,
      9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9, 10.0, 10.1, 10.2, 10.3,
    ],
  },
  2: {
    P3: [
      8.3, 8.5, 8.7, 8.9, 9.1, 9.3, 9.5, 9.7, 9.9, 10.1, 10.3, 10.5, 10.7, 10.9,
      11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9,
    ],
    P25: [
      9.0, 9.2, 9.4, 9.6, 9.8, 10.0, 10.2, 10.4, 10.6, 10.8, 11.0, 11.2, 11.4,
      11.6, 11.8, 12.0, 12.2, 12.4, 12.6, 12.8, 13.0, 13.2, 13.4, 13.6,
    ],
    P50: [
      9.8, 10.0, 10.2, 10.4, 10.6, 10.8, 11.0, 11.2, 11.4, 11.6, 11.8, 12.0,
      12.2, 12.4, 12.6, 12.8, 13.0, 13.2, 13.4, 13.6, 13.8, 14.0, 14.2, 14.4,
    ],
    P75: [
      10.6, 10.8, 11.0, 11.2, 11.4, 11.6, 11.8, 12.0, 12.2, 12.4, 12.6, 12.8,
      13.0, 13.2, 13.4, 13.6, 13.8, 14.0, 14.2, 14.4, 14.6, 14.8, 15.0, 15.2,
    ],
    P97: [
      11.4, 11.6, 11.8, 12.0, 12.2, 12.4, 12.6, 12.8, 13.0, 13.2, 13.4, 13.6,
      13.8, 14.0, 14.2, 14.4, 14.6, 14.8, 15.0, 15.2, 15.4, 15.6, 15.8, 16.0,
    ],
  },
  3: {
    P3: [
      12.3, 12.5, 12.7, 12.9, 13.1, 13.3, 13.5, 13.7, 13.9, 14.1, 14.3, 14.5,
    ],
    P25: [
      13.1, 13.3, 13.5, 13.7, 13.9, 14.1, 14.3, 14.5, 14.7, 14.9, 15.1, 15.3,
    ],
    P50: [
      13.9, 14.1, 14.3, 14.5, 14.7, 14.9, 15.1, 15.3, 15.5, 15.7, 15.9, 16.1,
    ],
    P75: [
      14.7, 14.9, 15.1, 15.3, 15.5, 15.7, 15.9, 16.1, 16.3, 16.5, 16.7, 16.9,
    ],
    P97: [
      15.5, 15.7, 15.9, 16.1, 16.3, 16.5, 16.7, 16.9, 17.1, 17.3, 17.5, 17.7,
    ],
  },
  4: {
    P3: [
      14.0, 14.5, 15.0, 15.5, 16.0, 16.5, 17.0, 17.5, 18.0, 18.5, 19.0, 19.5,
      20.0, 20.5, 21.0, 21.5, 22.0, 22.5, 23.0, 23.5,
    ],
    P25: [
      15.5, 16.0, 16.5, 17.0, 17.5, 18.0, 18.5, 19.0, 19.5, 20.0, 20.5, 21.0,
      21.5, 22.0, 22.5, 23.0, 23.5, 24.0, 24.5, 25.0,
    ],
    P50: [
      17.0, 17.5, 18.0, 18.5, 19.0, 19.5, 20.0, 20.5, 21.0, 21.5, 22.0, 22.5,
      23.0, 23.5, 24.0, 24.5, 25.0, 25.5, 26.0, 26.5,
    ],
    P75: [
      18.5, 19.0, 19.5, 20.0, 20.5, 21.0, 21.5, 22.0, 22.5, 23.0, 23.5, 24.0,
      24.5, 25.0, 25.5, 26.0, 26.5, 27.0, 27.5, 28.0,
    ],
    P97: [
      20.0, 20.5, 21.0, 21.5, 22.0, 22.5, 23.0, 23.5, 24.0, 24.5, 25.0, 25.5,
      26.0, 26.5, 27.0, 27.5, 28.0, 28.5, 29.0, 29.5,
    ],
  },
};

function diffInDays(d1, d2) {
  return Math.floor((d2.getTime() - d1.getTime()) / (1000 * 60 * 60 * 24));
}

function parseDOB(dobStr) {
  const [day, month, year] = dobStr.split("/").map(Number);
  return new Date(year, month - 1, day); // mes empieza en 0
}

export function getAgeUnits(dob, date) {
  const days = diffInDays(parseDOB(dob), new Date(date));
  const weeks = days / 7;
  const months = days / 30.4375; // promedio mes
  const years = days / 365.25;

  return { days, weeks, months, years };
}

export function getRange(ageMonths) {
  if (ageMonths < 6) return 0; // semanal
  if (ageMonths < 12) return 1; // semanal
  if (ageMonths < 36) return 2; // mensual
  if (ageMonths < 48) return 3; // mensual
  if (ageMonths <= 168) return 4; // semestral
  return null; // fuera de rango
}

export function mapToX(age, range) {
  switch (range) {
    case 0:
      return `Semana ${Math.round(age.weeks)}`; // 1 a 26
    case 1:
      return `Semana ${Math.round(age.weeks)}`; // 27 a 52
    case 2:
      return `${Math.round(age.months)} meses`; // 12 a 35
    case 3:
      return `${Math.round(age.months)} meses`; // 36 a 47
    case 4:
      return `${Math.round(age.years * 2) / 2} años`; // pasos de 0.5a (semestres)
    default:
      return -1;
  }
}
